import { styled } from "../../../../styles";

export const CustomFieldEditorContainer = styled("div", {
  width: "143px",
  display: "flex",
  flexDirection: "column",
  gap: "4px",
});

// Matches the height and left offset of the compact card inputs so a YesNo field doesn't make its
// card taller than the rest (the Toggle itself is only 28x15).
export const ToggleRow = styled("div", {
  display: "flex",
  alignItems: "center",
  height: "25px",
  margin: "4px 0 0 8px",
});

// Same treatment as the built-in cards' AlertText, so custom-field validation reads identically.
export const CustomFieldEditorError = styled("span", {
  color: "$error-light",
  fontWeight: 600,
  fontSize: "$text-md",
  lineHeight: "16px",
  padding: "$1 0 0 $3",
  fontFamily: "$openSans",
  wordBreak: "break-word",
});
